import { useMemo, useCallback } from "react";
import axios from "axios";
import useSWR from "swr";
import { formatTimeSheetParams } from "./helpers";

export const useManagerView = (params) => {
	const url = useMemo(() => {
		if (!params || !params.from || !params.to) {
			return null;
		}
		const url = axios.getUri({
			url: "/time-sheet/manager-view",
			params: formatTimeSheetParams(params),
		});
		return url;
	}, [params]);

	const requestConfig = useMemo(() => ({ url }), [url]);

	const {
		data: baseData,
		isLoading,
		mutate,
	} = useSWR(requestConfig);

	const data = useMemo(() => {
		if (!baseData) {
			return { result: [], totalItems: 0 };
		}
		return baseData;
	}, [baseData]);

    const setTotalItems = useCallback((argument) => {
        let value = argument;
		if (typeof argument === "function") {
			value = argument(data.totalItems);
		}
		mutate({
            result: data.result,
            totalItems: value,
        }, { revalidate: false });
    }, [data, mutate]);

	const setData = useCallback((argument) => {
        let value = argument;
		if (typeof argument === "function") {
			value = argument(data.result);
		}
		mutate({
            result: value,
            totalItems: data.totalItems,
        }, { revalidate: false });
	}, [data, mutate]);

	const refetch = useCallback(() => {
		return mutate();
	}, [mutate]);

	return {
		data,
		isLoading,
		mutate,
		refetch,
		setTotalItems,
		setData,
	};
};
